export default {
  ALICE_BLUE: '#f0f9ff',
  BUTTON_DISABLED: '#bebebe',
  HAWKES_BLUE: '#e5f2fd',
  MALIBU: '#80c9ff',
  KRAIN: '#3F709C',
  SEAGULL: '#83D2E8',
  CERULEAN: '#00abd1',
  JAVA: '#19AED3',
  JACARTA: '#2f2867',
  BUTTERFLY_BUSH: '#5b4999',
  VERY_SOFT_BLUE: '#8E98F1',
  SOFT_BLUE: '#8980F6',
  ERROR_COLOR: '#c1211e',
  RUST: '#B23A0B',
  APPLE_BLOSSOM: '#a94442',
  ALIZARIN_CRIMSON: '#e73427',
  INTERNATIONAL_ORANGE: '#FB4F00',
  RED_ORANGE: '#fe451f',
  FLAMENKO: '#ff7f06',
  FLAMENKO_LIGHT: '#fd9126',
  SUPERNOVA: '#FFCE0A',
  ENERGY_YELLOW: '#F8D14F',
  SANDWISP: '#f6efa0',
  BEESWAX: '#FDEFC3',
  CAPER: '#c3e8a8',
  ATLANTIS: '#6dc12e',
  HEAR: '#F7723E',
};
